import React, { useEffect, useState } from 'react';
import Sidebar from '../../components/Sidebar';
import '../CompanyHistory.css';
import { db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';

const DeliveryPerformance = () => {
  const [activeSection] = useState('delivery-performance');
  const [deliveryFiles, setDeliveryFiles] = useState(null);
  const customItems = Array.isArray(deliveryFiles?.customItems)
    ? deliveryFiles.customItems
    : [];
  
  const sidebarItems = [
    { name: 'Delivery Performance', path: 'delivery-performance' }
  ];

  // Download handler
  const handleDownload = ({ url, filename }) => {
    if (url) {
      window.open(url, '_blank', 'noopener,noreferrer');
      return;
    }

    const link = document.createElement('a');
    link.href = `/delivery-files/${filename}`;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  useEffect(() => {
    const load = async () => {
      try {
        const snap = await getDoc(doc(db, 'site-config', 'delivery-files'));
        setDeliveryFiles(snap.exists() ? snap.data() : null);
      } catch (e) {
        console.error('Failed to load delivery config:', e);
      }
    };
    load();
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'auto' });
    }
  };


  return (
    <>
      <Sidebar 
        category="Delivery Performance" 
        items={sidebarItems}
        activeSection={activeSection}
        onItemClick={scrollToSection}
      />
      <div className="company-history-page">
        <div className="history-container">
          <h1 className="page-category-title">Delivery Performance</h1>
          
          <div className="delivery-description">
            <p>
              Taebong Industrial Technology has been providing high-quality heat exchanger systems 
              to various industrial sectors with 40 years of accumulated technology and expertise.
            </p>
          </div>
          
          {/* Download Section */}
          <section id="delivery-performance" className="section">
            <h3 className="download-section-title">Delivery Performance Data Download</h3>
            <div className="delivery-split-container">
              {/* Left: Industrial Delivery Performance */}
              <div className="delivery-left">
                <div className="delivery-card-enhanced">
                  <div className="card-header">
                    <div className="card-icon">
                      <img src="/excel.jpeg" alt="Excel" className="excel-icon" />
                    </div>
                    <div className="card-info">
                      <h4 className="card-title">Industrial Delivery Performance</h4>
                    </div>
                  </div>
                  <div className="card-content">
                    <div className="card-features">
                      <span className="feature-tag">Plant Equipment</span>
                    </div>
                  </div>
                  <button 
                    className="download-btn-enhanced"
                    onClick={() =>
                      handleDownload({
                        url: deliveryFiles?.industrial?.fileUrl,
                        filename: '산업용_납품실적_2021_2024.xlsx',
                      })
                    }
                  >
                    <span className="btn-icon">⬇️</span>
                    <span className="btn-text">Download</span>
                  </button>
                </div>
              </div>

              {/* Right: Compact Unit Delivery Performance */}
              <div className="delivery-right">
                <div className="delivery-card-enhanced">
                  <div className="card-header">
                    <div className="card-icon">
                      <img src="/excel.jpeg" alt="Excel" className="excel-icon" />
                    </div>
                    <div className="card-info">
                      <h4 className="card-title">Compact Unit Delivery Performance</h4>
                    </div>
                  </div>
                  <div className="card-content">
                    <div className="card-features">
                      <span className="feature-tag">HVAC</span>
                    </div>
                  </div>
                  <button 
                    className="download-btn-enhanced"
                    onClick={() =>
                      handleDownload({
                        url: deliveryFiles?.compact?.fileUrl,
                        filename: 'Compact_Unit_납품실적_2023_2024.xlsx',
                      })
                    }
                  >
                    <span className="btn-icon">⬇️</span>
                    <span className="btn-text">Download</span>
                  </button>
                </div>
              </div>
            </div>

            {customItems.length > 0 && (
              <div style={{ marginTop: '2rem' }}>
                <h3 className="download-section-title">Additional Downloads</h3>
                <div className="delivery-split-container" style={{ gap: '2rem' }}>
                  {customItems.map((it) => (
                    <div key={it.id} className="delivery-left" style={{ flex: 1 }}>
                      <div className="delivery-card-enhanced">
                        <div className="card-header">
                          <div className="card-icon">
                            <img src="/excel.jpeg" alt="Excel" className="excel-icon" />
                          </div>
                          <div className="card-info">
                            <h4 className="card-title">
                              {it.titleEn || it.titleKo || 'Delivery Performance'}
                            </h4>
                          </div>
                        </div>
                        <div className="card-content">
                          <div className="card-features">
                            {(it.tagEn || it.tagKo || '').trim() && (
                              <span className="feature-tag">
                                {it.tagEn || it.tagKo}
                              </span>
                            )}
                          </div>
                        </div>
                        <button
                          className="download-btn-enhanced"
                          onClick={() =>
                            handleDownload({
                              url: it.fileUrl,
                              filename: it.fileName || 'delivery.xlsx',
                            })
                          }
                        >
                          <span className="btn-icon">⬇️</span>
                          <span className="btn-text">Download</span>
                        </button>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </section>
        </div>
      </div>
    </>
  );
};

export default DeliveryPerformance;